<template>
  <b-container fluid>
    <b-modal id="modal-3ds" hide-footer hide-header size="xl" centered>
      <iframe
        :src="threeDSUrl"
        style="width: 100%; height: 80vh; border: none;"
      ></iframe>
    </b-modal>

    <b-row class="bg-custom py-2">
      <b-container fluid="xl">
        <b-row class="align-items-center header-content">
          <b-col
            cols="12"
            lg="auto"
            class="header-inner"
          >
            <img
              src="@/assets/images/logo/soulpay.png"
              alt="SoulPay"
              class="logo"
            />
          </b-col>

          <b-col
            cols="12"
            lg="auto"
            class="header-inner"
          >
            <h2 class="mb-0 text-white">Link de Pagamento</h2>
          </b-col>
        </b-row>
      </b-container>
    </b-row>
    

    <b-card v-if="renderPage">
      <b-card v-if="showPaymentInput" class="card-form no-bg-card">
        <b-tabs v-model="activeTab">
        <b-tab :value="0">
          <template #title>
            <feather-icon icon="CreditCardIcon" />
            <span>Cartão</span>
          </template>
        <b-row class="mb-2 column-change">
          <b-col cols="12" md="6" lg="8"  class="bg-white">
            <validation-observer ref="simpleRules">
              <b-form @submit.prevent>

                <b-card-body >
                  <h5 class="mb-3">Dados do Cartão</h5>
                  <b-row>
                   <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Nome do titular do cartão"
                        label-for="v-cardName"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Nome do titular do cartão"
                          rules="required"
                        >
                          <b-form-input
                            id="v-cardName"
                            v-model="req.credit_card.card_holder_name"
                            type="text"
                            placeholder="Nome do titular do cartão"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Número cartão"
                        label-for="v-credit-card"
                      >
                    <validation-provider
                      ref="cardProvider"
                      #default="{ errors }"
                      name="Número cartão"
                      :rules="cardRules"
                    >
                          <b-input-group
                            class="input-group-merge"
                            :class="errors.length > 0 ? 'is-invalid':null"
                          >
                            <b-form-input
                              id="v-credit-card"
                              v-model="req.credit_card.card_number"
                              v-mask="['#### #### #### ####', '#### ###### #####']"
                              @input="onCardInput"
                              type="tel"
                              placeholder="Informe o número do cartão"
                              :state="errors.length > 0 ? false : null"
                            />
                             <b-input-group-append
                              v-if="showFlagCard"
                              is-text
                            >
                              <b-img
                                :style="`width: ${card.size}em`"
                                :src="cardBrandIcon"
                              />
                            </b-input-group-append>
                          </b-input-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                     <b-col
                      sm="12"
                      md="12"
                      lg="2"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="CVV"
                        label-for="v-card-cvv"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="CVV"
                          rules="required|cvv"
                        >
                          <b-form-input
                            id="v-card-cvv"
                            v-model="req.credit_card.cvv"
                            v-mask="['###', '####']"
                            placeholder="CVV"
                            pattern="/d*"
                            type="tel"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                     <b-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="3"
                    >
                      <b-form-group
                        label="Expiração"
                        label-for="v-month"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Mês"
                          rules="required"
                        >
                          <b-form-select
                            id="v-month"
                            v-model="month"
                            :options="optionsMonths"
                          >
                            <template v-slot:first>
                              <b-form-select-option
                                :value="null"
                                disabled
                              >
                                Mês
                              </b-form-select-option>
                            </template>
                          </b-form-select>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
 
                      <b-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="3"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Ano"
                        :rules="month ? `required|date:${month}`: 'required'"
                      >
                      <label for="v-year">Ano</label>
                        <b-form-select
                          id="v-year"
                          v-model="year"
                          class="year mt-0"
                          :options="optionsYears"
                          :state="errors.length > 0 ? false : null"
                        >
                          <template v-slot:first>
                            <b-form-select-option
                              disabled
                              :value="null"
                            >
                              Ano
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <b-col
                      sm="12"
                      md="12"
                      lg="4"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Número de parcelas"
                        label-for="v-installment"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Número de parcelas"
                          rules="required"
                        >
                          <b-form-select
                            id="v-installments"
                            v-model="req.payment.installments"
                            :options="installment"
                            :state="errors.length > 0 ? false : null"
                          >
                            <template v-slot:first>
                              <b-form-select-option
                                :value="null"
                                disabled
                              >
                                Selecione o número de parcelas
                              </b-form-select-option>
                            </template>
                          </b-form-select>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-body>

                <hr />

                <b-card-body>
                  <h5 class="mb-3">Dados do Portador do Cartão</h5>
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Nome Completo"
                        label-for="v-first-name"
                      >
                        <validation-provider
                          #default="{ errors }"
                          rules="required"
                          name="Nome Completo"
                        >
                          <b-form-input
                            id="v-first-name"
                            v-model="req.customer.name"
                            placeholder="Digite o nome do cliente"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                      <b-col
                      sm="12"
                      md="12"
                      lg="6"
                    >
                      <b-form-group
                        label="Documento"
                        label-for="v-document"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Documento"
                          :rules="`required|${isForeigner ? '' : 'document'}`"
                        >
                          <b-form-input
                            id="v-document"
                            v-model="req.credit_card.tax_id"
                            v-mask="isForeigner ? ['#################'] : [
                              '###.###.###-##',
                              '##.###.###/####-##',
                              '##.###.###',
                            ]"
                            type="text"
                            placeholder="Informe o Documento"
                            :state="errors.length > 0 ? false : null"
                            style="width: 100%"
                          />

                          <small class="text-danger">{{
                            errors[0]
                          }}</small></validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                      <b-col
                        sm="12"
                        md="12"
                        lg="6"
                        offset-xl="0"
                      >
                        <b-form-group
                          label="E-mail"
                          label-for="v-email"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="E-Mail"
                            rules="required|email"
                          >
                          <b-form-input
                            id="v-email"
                            v-model="req.customer.email"
                            type="email"
                            placeholder="Email"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                     <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Telefone"
                        label-for="v-mobile"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Telefone"
                          rules="required|phone"
                        >
                          <b-form-input
                            id="v-mobile"
                            v-model="req.customer.phone1"
                            v-mask="['(##) #####-####', '(##) ####-####']"
                            placeholder="Informe o telefone"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                      <b-col
                        sm="12"
                        md="6"
                        lg="6"
                      >
                        <b-form-group
                          label="Data de Nascimento"
                          label-for="v-born"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Data de Nascimento"
                            rules="required|bornDate"
                          >
                        <b-input-group class="birth-date-group">
                          <b-form-input
                            id="v-born"
                            v-model="req.customer.dob"
                            v-mask="'##/##/####'"
                            placeholder="dd/mm/aaaa"
                            type="text"
                            inputmode="numeric"
                            autocomplete="off"
                            :state="errors.length > 0 ? false : null"                          
                          />
                          
                          <b-input-group-append>
                            <b-form-datepicker
                              v-model="internalDate"
                              button-only
                              right
                              locale="pt-BR"
                              aria-controls="v-born"
                              @input="onDateSelected"
                              class="birth-date-picker border-left-0"
                            />
                          </b-input-group-append>
                        </b-input-group>

                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>

                    </b-col>

                      <b-col
                        sm="12"
                        md="6"
                        lg="6"
                        class="d-flex align-items-center mt-md-0 mt-2"
                      >
                        <b-form-checkbox
                          id="is-foreigner"
                          v-model="isForeigner"
                        >
                        É estrangeiro?
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-card-body>

                <hr />

                <b-card-body>
                  <h5 class="mb-3">Endereço Portador do Cartão</h5>
                <b-row>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="País"
                        label-for="v-country"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="País"
                          rules="required"
                        >
                          <b-form-select
                            id="v-country"
                            v-model="req.billing.country"
                            :options="options"
                            :state="errors.length > 5 ? false : null"
                            selected="32"
                          >
                            <template v-slot:first>
                              <b-form-select-option value="BR">
                                Brasil
                              </b-form-select-option>
                            </template>
                          </b-form-select>
                          <small class="text-danger">
                            {{ errors[0] }}
                          </small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="CEP"
                        label-for="v-cep"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="CEP"
                          :rules="`required|${req.billing.country == 'BR' ? `cep: ${req.billing.state}` : ''}`"
                        >
                        <b-form-input
                          id="v-cep"
                          v-model="req.billing.postal_code"
                          placeholder="CEP"
                          :state="errors.length > 5 ? false : null"
                          :maxlength="req.billing.country === 'BR' ? 9 : 10"
                          :inputmode="req.billing.country === 'BR' ? 'numeric' : 'text'"
                          v-mask="cepMask"
                           @change="req.billing.country==='BR' ? searchPostalCode() : ''"
                        />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Estado"
                        label-for="v-state"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Estado"
                          :rules="req.billing.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-state"
                            v-model="req.billing.state"
                            placeholder="Estado"
                            :state="errors.length > 5 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Cidade"
                        label-for="v-city"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Cidade"
                          :rules="req.billing.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-city"
                            v-model="req.billing.city"
                            placeholder="Cidade"
                            :state="errors.length > 5 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                     <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Endereço"
                        label-for="v-address"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Endereço"
                          :rules="req.billing.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-address"
                            v-model="req.billing.address"
                            placeholder="Endereço"
                            :state="errors.length > 5 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                     <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Bairro"
                        label-for="v-district"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Bairro"
                          :rules="req.billing.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-district"
                            v-model="req.billing.district"
                            placeholder="Bairro"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                     <b-col
                      sm="12"
                      md="6"
                      lg="3"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Número"
                        label-for="v-number"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Número"
                          rules="required"
                        >
                          <b-form-input
                            id="v-number"
                            v-model="req.billing.number"
                            type="tel"
                            placeholder="Número"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                      <b-col
                      sm="12"
                      md="6"
                      lg="3"
                    >
                      <b-form-group
                        label="Complemento"
                        label-for="v-complemento"
                      >
                        <b-input-group class="input-group-merge">
                          <b-form-input
                            id="v-complemento"
                            v-model="req.billing.complement"
                            placeholder="Complemento"
                          />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-body>

                <div
                v-if="showPaymentInput"
                align="center"
              >
                <b-button
                  variant="info"
                  :disabled="isSubmitting"
                  @click="validationForm()"
                >
                  {{ buttonNextPage }}
                </b-button>
              </div>
              </b-form>
            </validation-observer>
          </b-col>
          <!-- desc card -->
          <b-col
            sm="12"
            md="6"
            lg="4"
            class="py-2"
          >
            <information
              :data="res"
              :value-with-interest="valueWithInterest"
              type="first"
            />
          </b-col></b-row>
          </b-tab>

           <b-tab :value="1">
             <template #title>
                <img 
                  src="@/assets/images/icons/pix.png" 
                  style="width: 18px; margin-right: 6px;"
                />
                <span>Pix</span>
              </template>
              <b-row >
                  <b-col cols="12" >
                  <PaymentPix 
                  :hash="hash"
                  :res="res" />
                </b-col>
              </b-row>
            </b-tab>
  </b-tabs>
      </b-card>
      <div v-if="!showPaymentInput">
      <b-row class="d-flex align-items-center justify-content-center">
        <template v-if="res.link.status.code === 22">
          <b-col cols="12" class="d-flex flex-column align-items-center text-center">
            <icon :type="res.link.status.icon" class="mb-0" />
            <h3 class="mt-1">{{ res.link.status.text }}</h3>
          </b-col>
        </template>
        <template v-else>
          <icon :type="res.link.status.icon" />
          <div class="text-center ml-2">
             <h3> {{ res.link.status.text }} </h3>
          </div>
        </template>
      </b-row>
        <div v-if="![12, 5,22].includes(res.link.status.code)"> 
          <b-col
            md="12"
            xl="12"
          >
            <Receipt
              :receipt-data="res"
              type="transaction"
            />
          </b-col>
        </div>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import {
  BRow,
  BTabs,
  BTab,
  BCardHeader,
  BFormDatepicker,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BFormCheckbox,
  BForm,
  BInputGroup,
  BButton,
  BCard,
  BCardBody,
  BImg,
  BContainer,
  BInputGroupAppend,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  required,
} from '@validations'
import Ripple from 'vue-ripple-directive'

import {
  DateTime,
} from 'luxon'
import Icon from '@/layouts/components/Icon.vue'
import Receipt from '@/layouts/components/Receipt.vue'
import Information from '@/layouts/components/payment-link/Information.vue'
import ContactCard from '@/layouts/components/payment-link/contactCard.vue'
import PaymentPix from './PaymentPix.vue'
import { payLink, getLink, getPaymentLinkError } from '@/service/pay/pay'
import { getPostalCode, getUserInfo } from '@/service/others/others'

import { callLoading } from '@/service/utilities/utilities'

import { doInstallments, doCardBrand } from '@/service/utilities/payment-link/payment-link'

const countries = require('@/information/countries').default
const months = require('@/information/months').default

export default {
  components: {
    BContainer,
    BTabs,
    BTab,
    BCardHeader,
    BInputGroupAppend,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormCheckbox,
    BInputGroup,
    BForm,
    BButton,
    BImg,
    BCard,
    BCardBody,
    Icon,
    Receipt,
    Information,
    PaymentPix,
    ContactCard
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      internalDate: '',
      pixPollingInterval: null, 
      activeTab: 0,
      isForeigner: false,
      renderPage: false,
      showFlagCard: false,
      year: null,
      month: null,
      options: countries,
      showPaymentInput: true,
      optionsMonths: months,
      awaiting3DSAuthentication: false,
      installment: [],
      optionsYears: [],
      buttonNextPage: 'Pagar',
      checkConfirmModal: false,
      isSubmitting: false,
      threeDSUrl: null,
      res: {
        link: {
          status: {},
        },
        product: {},
        user: {},
        customer: {},
        payment: {},
      },
      req: {
        customer: {
          name: null,
          email: null,
          dob: null,
          ip: null,
          tax_id: null,
          phone1: null,
          created_at: null,
          new: true,
          vip: false,
        },
        credit_card: {
          card_holder_name: null,
          card_number: null,
          expiration_date: null,
          cvv: null,
          tax_id: null,
        },
        payment: {
          value: null,
          installments: null,
          currency: 'BRL',
          lock_card: false,
        },
        billing: {
          name: null,
          address: null,
          number: null,
          complement: null,
          city: null,
          district: null,
          state: null,
          postal_code: null,
          country: 'BR',
          phone: null,
          email: null,
        },
      },
      card: {
        image: null,
        size: null,
      },
      typeStatus: {
        1: {
          code: 1,
          icon: 'success',
          text: 'Pagamento Foi Aprovado',
          status: 'Aprovado',
        },
        3: {
          code: 3,
          icon: 'warning',
          text: 'Pagamento em Revisão',
          status: 'Revisão',
        },
        5: {
          code: 5,
          icon: 'loading',
          text: 'Pagamento em Processamento',
          status: 'Revisão',
        },
        12: {
          code: 12,
          icon: 'danger',
          text: 'Esse link não é mais válido. ',
        },
        22: { 
          code: 22,
          icon: 'loading',
          text: 'Aguardando autenticação.\nFinalize a confirmação no aplicativo do seu banco para continuar.',
          variant: 'warning',
        }
      },
    }
  },
  
watch: {
  activeTab(newTab) {
    if (newTab === 1) {
      this.startPixPolling()
    } else {
      this.stopPixPolling()
    }
  }
},
  computed: {
    valueWithInterest() {
      return this.installment[this.req.payment.installments - 1]?.priceWithInterest
    },
cardRules() {
  return {
    required: true,
    binLocked: {
      locked: this.req.payment.lock_card,
    },
    'credit-card': true,
  }
},

    cepMask() {
      return this.req.billing.country === 'BR'
        ? '#####-###'
        : null 
    },

    cardBrandIcon() {
      return require(`@/assets/images/paymentIcons/${this.card.image}.svg`)
    },
  },
  async mounted() {
    callLoading(true)
    this.resizeScreen()
    window.addEventListener('resize', this.resizeScreen)
    document.addEventListener('visibilitychange', this.handleVisibilityChange)

        const { s } = this.$route.query
        const { hash } = this.$route.params
        this.hash = hash

       if (s === 'err') {
         sessionStorage.setItem('payment_3ds_error', 'true')

          const success = await this.handle3DSError(hash)

          if (success) {
            this.$router.replace({ query: {} })
          }

          this.$nextTick(() => {
            this.checkPaymentErrorPopup()
          })

          callLoading(false)
          return
        }

    await this.getPaymentLink()
    this.installment = doInstallments(this.res.payment)
    this.generateJsonYear()
    this.getUserInfo()
    callLoading(false)

    if (this.activeTab === 1) {
          this.startPixPolling()
    }
  },

    beforeDestroy() {
      this.stopPixPolling()
      document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    },
  methods: {
    onDateSelected(dateString) {
    if (dateString) {
      const [year, month, day] = dateString.split('-')
      this.req.customer.dob = `${day}/${month}/${year}`
    }
  },
     startPixPolling() {
        
    if (this.pixPollingInterval) return;

    this.pixPollingInterval = setInterval(async () => {
      try {
        const response = await getLink('payment-link', this.hash); 
        if (response.status === 200) {
          this.res = response.data;  

          if (this.res.link.status === 13) {
            clearInterval(this.pixPollingInterval);
            this.pixPollingInterval = null;
            this.$router.push(`/pagamento/status/${this.hash}`); 
          }
        }
      } catch (err) {
        console.error('Erro ao verificar status Pix', err);
      }
    }, 5000); 
  },

  stopPixPolling() {
    if (this.pixPollingInterval) {
      clearInterval(this.pixPollingInterval);
      this.pixPollingInterval = null;
    }
},
    checkCreditCard() {
      if (window.innerWidth < 500) {
        this.showFlagCard = false
        return
      }

      const cardValidate = doCardBrand(this.req.credit_card.card_number)

      if (cardValidate) {
        const { cardImage, isPotentiallyValid } = cardValidate
        this.showFlagCard = !!cardImage
        this.card = cardImage
        this.isPotentiallyValid = isPotentiallyValid
      }
    },
    onCardInput() {
      this.checkCreditCard()

      this.$nextTick(() => {
        const provider = this.$refs.cardProvider
        if (provider) {
          provider.validate()
        }
      })
    },

    async createModal() {
      await this.$bvModal
        .msgBoxConfirm('Confirmar Pagamento?', {
          title: 'Por Favor Confirme',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        }).then(value => {
          this.checkConfirmModal = value
        })
    },

    error(errorText) {
      this.$swal({
        title: errorText,
        icon: 'error',
        timer: 2000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    async handle3DSError() {
      try {
        await getPaymentLinkError(this.hash)
        await this.getPaymentLink() 
        this.showPaymentInput = true
        this.renderPage = true

        this.awaiting3DSAuthentication = false

        return true
      } catch {
        this.error('Erro ao processar falha do 3DS')
        this.renderPage = true
        this.showPaymentInput = false
        this.awaiting3DSAuthentication = false
        return false
      }
    },

    checkPaymentErrorPopup() {
      const has3dsError = sessionStorage.getItem('payment_3ds_error')

      if (has3dsError && this.showPaymentInput) {
        this.$swal({
          title: 'Pagamento não concluído',
          text: 'Seu pagamento falhou ou não foi autenticado. Por favor, tente novamente.',
          icon: 'error',
          confirmButtonText: 'Entendi',
          allowOutsideClick: false,
        }).then(() => {
          sessionStorage.removeItem('payment_3ds_error')
        })
      }
    },

    generateJsonYear() {
      const date = new Date()
      const yearToday = date.getFullYear()
      for (let i = yearToday; i < yearToday + 15; i += 1) {
        this.optionsYears.push({
          value: i,
          text: i,
        })
      }
    },
    
    async getUserInfo() {
      try {
        const linkHash = this.res?.link?.hash
        const responseIP = await getUserInfo(linkHash)
        const { ip } = responseIP.data
        this.req.customer.ip = ip
            
      } catch {
        this.req.customer.ip = '179.191.67.2'
      }},
    open3DSModal(url) {
      this.threeDSUrl = url
      this.$bvModal.show("modal-3ds")
    },

      handleVisibilityChange() {
        if (
          document.visibilityState === 'visible' &&
          this.awaiting3DSAuthentication
        ) {
          this.getPaymentLink()
        }
      },


    async getPaymentLink() {
      const { hash } = this.$route.params
      this.hash = hash
      const response = await getLink('payment-link', hash)
      if (response.status === 200) {
        
        this.res = response.data
        this.req.payment.value = +this.res.payment.value
        this.req.payment.lock_card = this.res.payment.lock_card === true || this.res.payment.lock_card === 'true'

        if (this.res.link.status === 1 || this.res.link.status === 3 || this.res.link.status === 5 || this.res.link.status === 12 || this.res.link.status === 22) {
          this.showPaymentInput = false
          this.res.link.status = this.typeStatus[this.res.link.status]
          this.awaiting3DSAuthentication = this.res.link.status.code === 22
          this.res.payment.transaction_date = DateTime.fromISO(this.res.payment.transaction_date).plus({hours: 3}).toFormat(
            'dd/MM/yyyy',
          )
        this.$nextTick(() => {
          if (this.$refs.simpleRules) {
            this.$refs.simpleRules.validate()
          }
        })
        } else { this.showPaymentInput = true }
        this.renderPage = true
      } else { this.renderPage = false }
    },

async payLink() {
  const hash = this.hash || this.$route.params.hash
  let isRedirecting = false
  try {
    await this.createModal()
    if (!this.checkConfirmModal) {
      return
    }
    callLoading(true, true)

    this.updateObjectPayment() 

    const { customer, shipping, ...partialReq } = this.req
    const cleanReq = JSON.parse(JSON.stringify(partialReq))
    cleanReq.credit_card.card_number = cleanReq.credit_card.card_number.replace(/\s+/g, '')
    cleanReq.billing.postal_code = cleanReq.billing.postal_code.replace('-', '')
    cleanReq.credit_card.expiration_date = `${this.month}/${this.year}`


    const userInfo = await getUserInfo(this.res.link.hash)
    if (userInfo.threeDSecure) {
      cleanReq.threeDSecure = userInfo.threeDSecure
    }

    const response = await payLink('payment-link', this.hash, cleanReq)
    const { status } = response

      // apiResponse indicates a declined/failed transaction regardless of the
      // HTTP status returned (the gateway can respond with HTTP 200 even when
      // the card authentication/authorization failed), so it must be checked
      // before treating the request as successful.
      if (response.data.apiResponse === "AUTHENTICATION_REQUIRED") {
        this.awaiting3DSAuthentication = true
        const redirectUrl = response.data.url
        window.location.href = redirectUrl
        isRedirecting = true
        return
      }

      if (response.data.apiResponse === "CARD_AUTHENTICATION_FAILED") {
        this.error('Não foi possível autenticar o cartão. Entre em contato com o banco emissor ou utilize outro cartão.')
      } else if (status === 200) {
        isRedirecting = true
        try {
          await this.$router.push(`/pagamento/status/${this.hash}`)
        } catch (navErr) {
          isRedirecting = false
        }
      } else if (response.data.response_message == 'AUTHORIZATION_ERROR') {
        this.error('Pagamento negado pelo emissor. Entre em contato com o emissor do cartão.')
      } else if (response.data.response_message == 'INSUFFICIENT_FUNDS') {
        this.error('Pagamento negado por falta de limite ou saldo. Tente outro cartão ou entre em contato com o emissor.')
      } else if (response.data.response_message == 'UNAUTHORIZED_CONTACT_ISSUER') {
        this.error('Pagamento não autorizado pelo emissor do cartão. Entre em contato com o banco emissor para mais informações.')
      } else if (response.data.response_message == 'UNAUTHORIZED_NO_RETRY') {
        this.error('Pagamento não autorizado. Por favor, utilize outro cartão para concluir a compra.')
      } else if ([5, 255, 259].includes(response.data.response_code)) {
        this.error('Pagamento negado pelo emissor. Entre em contato com o emissor do cartão.')
      } else if (response.data.response_code == 9) {
        this.error('Data do vencimento do cartão de crédito preenchido incorreto.')
      } else if (response.data.response_code == 11) {
        this.error('Número do cartão de crédito errado ou inexistente.')
      } else if (response.data.response_code == 13) {
        this.error('Número CVV do cartão é inválido.')
      } else {
        this.error('Pagamento negado pelo emissor. Entre em contato com o emissor do cartão.')
      }
      } finally {
        if (!isRedirecting) {
          callLoading(false)
          this.isSubmitting = false
        }
      }
    },

    resizeScreen() {
      if (window.innerWidth < 500) {
        this.showFlagCard = false
        return
      }
      this.showFlagCard = this.cardIsPotentiallyValid
    },

    async searchPostalCode() {
      const { data } = await getPostalCode(this.req.billing.postal_code)
      const {
        address, city, district, state,
      } = data

      this.req.billing.state = state
      this.req.billing.city = city
      this.req.billing.address = address
      this.req.billing.district = district
    },

    updateObjectPayment() {
      this.req.billing.postal_code = this.req.billing.postal_code.replace('-', '')
      this.req.billing.email = this.req.customer.email
      this.req.billing.name = this.req.customer.name
      this.req.billing.phone = this.req.customer.phone1

      this.req.credit_card.card_number = this.req.credit_card.card_number.replaceAll(' ', '')
      this.req.credit_card.expiration_date = `${this.month}/${this.year}`

      const date = new Date()
      this.req.customer.created_at = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

      const [day, month, year] = this.req.customer.dob.split('/')

      this.req.billing.birth_date = `${year}-${month}-${day}`
    },
    scrollToFirstError() {
      this.$nextTick(() => {
        const firstError = document.querySelector('.is-invalid, .text-danger')
        if (firstError) {
          firstError.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        }
      })
    },
    validationForm() {
      if (this.isSubmitting) return
      this.isSubmitting = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.payLink()
        } else {
          this.isSubmitting = false
          this.$swal({
            title: 'Formulário com erros',
            text: 'Por favor, verifique os campos destacados antes de continuar.',
            icon: 'warning',
            confirmButtonText: 'Ok',
            allowOutsideClick: false,
          })
          this.scrollToFirstError()
        }
      }).catch(() => {
        this.isSubmitting = false
      })
    }
  },
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
h1,h2,h3,h4,h5,h6,p, a,label {
  font-family: 'Poppins', sans-serif;
}
h3 {
  white-space: pre-line;
}
.header-content {
  justify-content: center; 
  text-align: center;
}

@media (min-width: 992px) {
  .header-content {
    justify-content: flex-start; 
    margin-left: 13%;        
    text-align: left;
  }
}

.logo {
  height: 40px;
}

.birth-date-group {
  height: 38px;
}

.birth-date-group > .form-control,
.birth-date-group .birth-date-picker,
.birth-date-group .birth-date-picker > button {
  height: 38px;
}

.birth-date-group .birth-date-picker > button {
  padding-top: 0;
  padding-bottom: 0;
}

  @import "@core/scss/vue/pages/page-payment-link.scss";
</style>
